import { SUBSCRIPTION_PLAN } from '@gymaholic/packages'

/**
 * @param selectedSubscriptionPlan
 * @returns {string}
 */
export const getYearlyVersionOfSelectedSubscriptionUserSelectUtil = ({
  selectedSubscriptionPlan
}) => {
  if ([
    SUBSCRIPTION_PLAN.PREMIUM,
    SUBSCRIPTION_PLAN.PREMIUM_2025
  ].includes(selectedSubscriptionPlan)) {
    return SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025
  }

  if (selectedSubscriptionPlan === SUBSCRIPTION_PLAN.PREMIUM_PLUS_2025) {
    return SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_2025
  }

  if (selectedSubscriptionPlan === SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025) {
    return SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025
  }

  if (selectedSubscriptionPlan === SUBSCRIPTION_PLAN.PREMIUM_PLUS_SALE_2025) {
    return SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_SALE_2025
  }
}
